import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getIsCheckoutLoyaltyInternationalTrip from './getIsCheckoutLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'

const getCanRedeemLoungePassLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => getIsCheckoutLoyaltyInternationalTrip(state),
  (state: App.State) => state.loyalty.config?.loungePassExperienceIds,
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (userBenefits, isInternationalTrip, loungePassIds = EmptyArray, isCurrentRegionUserLoyaltyRegion): boolean => {
    if (!isCurrentRegionUserLoyaltyRegion) return false
    const loungePassBenefit = userBenefits?.find(benefit => benefit.code === 'lounge_pass')

    // Can redeem lounge passes when they have some remaining, it's an international order
    // and our config says we have lounge pass experiences available
    return loungePassIds.length > 0 &&
      !!loungePassBenefit &&
      (loungePassBenefit.unlimited || !!loungePassBenefit.remaining) &&
      isInternationalTrip
  },
)

export default getCanRedeemLoungePassLoyaltyBenefit
